import { Input } from '../ui/input';
import { tennisCarats } from '../../lib/tennis';

export const TennisPriceInputs = ({ productType, value, onChange, testIdPrefix = 'tennis-price', inputClassName = '' }) => {
  const carats = tennisCarats(productType);
  return (
    <div className={`grid grid-cols-4 gap-2 ${carats.length > 6 ? 'sm:grid-cols-7' : 'sm:grid-cols-6'}`} data-testid={`${testIdPrefix}-grid`}>
      {carats.map((c) => (
        <label key={c} className="block">
          <span className="block text-[11px] font-semibold text-zinc-600 mb-1">{c} CT</span>
          <span className="relative block">
            <span className="absolute left-2.5 top-1/2 -translate-y-1/2 text-xs text-zinc-400 pointer-events-none">$</span>
            <Input
              type="number"
              min="1"
              step="1"
              inputMode="decimal"
              value={value?.[c] ?? ''}
              onChange={(e) => onChange({ ...value, [c]: e.target.value })}
              placeholder="0"
              className={`h-9 pl-5 text-sm font-mono ${inputClassName}`}
              data-testid={`${testIdPrefix}-${c}`}
            />
          </span>
        </label>
      ))}
    </div>
  );
};
